import { IfAbility } from '@efdigital/ll-addon-auth';
import UsersSection from '@efdigital/ll-admin-v2/components/client-edit/users-section.gts';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditRecord } from '@efdigital/ll-admin-v2/components/edit-record.gts';
import type { LibraryClientsEditModel } from '@efdigital/ll-admin-v2/routes/library/clients/client';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    model: LibraryClientsEditModel;
  };
}

const UsersRoute: TemplateOnlyComponent<Signature> = <template>
  <IfAbility @ability="clients:users" @atLeast="viewer">
    <:if>
      <EditContext as |context|>
        <EditRecord
          @editLabel="Edit Users &amp; Access"
          @item={{@model.client}}
          @context={{context}}
          @buttonSize="btn-md"
        >
          <:form as |uniqueId isReadOnly|>
            <UsersSection
              @client={{@model.client}}
              @uniqueId={{uniqueId}}
              @isReadOnly={{isReadOnly}}
            />
          </:form>
        </EditRecord>
      </EditContext>
    </:if>
    <:else>
      <div class="alert alert-warning">
        You do not have permission to view or manage users for this client.
      </div>
    </:else>
  </IfAbility>
</template>;

export default UsersRoute;
